import React, { useContext } from "react";
import { Context } from "../../../Context";
import hash from "object-hash";
import { SignatureRequestView } from "../../views/index";
import {
  ValidateInputPure,
  SimpleLoading,
  VerifyContract,
  PromotionalFooterPure
} from "../../pures";
import {
  SignatureRequestService,
  SignerTypeService,
  LocalStorageService,
  ContractService,
  UserService,
  SignatureTypesService,
  ServiceService,
  ProcessTypeService,
  DomainService,
} from "../../../services";
import { SignatureRequestValidator } from "../../../validators/index";
import { Container, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import initialState from "../../../utils/initialState";

const gridInformationContactPlanStyles = {
  alignItems: "start",
  justifyContent: "space-between",
};
const containerInformationContactPlanStyles = {
  marginTop: "20px",
  marginBottom: "20px",
};
const globalContainerStyles = {
  backgroundColor: "white",
  marginLeft: "20px",
  maxWidth: "100%",
};

class DragCell extends React.Component {
  render() {
    return (
      <td
        onDragOver={(e) => {
          DragCell.reorder(this.props.dataItem);
          e.preventDefault();
          e.dataTransfer.dropEffect = "copy";
        }}
      >
        <span
          className="k-icon k-i-reorder"
          draggable="true"
          style={{ cursor: "move" }}
          onDragStart={(e) => {
            DragCell.dragStart(this.props.dataItem);
            e.dataTransfer.setData("dragging", "");
          }}
        />
      </td>
    );
  }
}

class SignatureRequestAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signatureTypesInputValue: [],
      signers: [],
      email: "",
      dataItem: {},
      name: "",
      description: "",
      eventId: "",
      comments: "",
      activeItem: null,
      activeItemValidator: null,
      signerTypeName: "",
      signerTypes: [],
      signatureRequests: [],
      signerTypesSelected: "",
      signerTypeSelected: "",
      visible: false,
      date: new Date(),
      signatureRequest: [],
      idCounter: 0,
      signerInEdit: undefined,
      userIsEditing: false,
      dialogTitle: "",
      selectedFile: null,
      numPages: null,
      pageNumber: 1,
      zoom: 1.0,
      validators: [],
      pagesArray: [],
      documentAccept: false,
      errorFile: false,
      errorAcceptDocument: false,
      errorNotSigners: false,
      errorCurrentEmail: false,
      errorCurrentEmailRegister: false,
      errorSignerType: false,
      errorCurrentName: false,
      errorCurrentLastName: false,
      errorNameUnique: false,
      errorSignatureTypeId: false,
      errorCurrentComments: false,
      errorCurrentDescription: false,
      disableSignerButton: true,
      showNotification: false,
      message: null,
      selectedFileName: "No se ha seleccionado ningún archivo",
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      errorNotValidators: false,
      visibleDialogDeleteSigner: false,
      signerToDelete: "",
      loadingContractsSignatures: true,
      contractsSignatures: {},
      buttonType: 0,
      getUserEmailFilterLoading: true,
      getUserEmailFilter: [],
      getUserNameFilterLoading: true,
      getUserNameFilter: {},
      firstLastName: "",
      firstName: "",
      getEmail: "",
      autocomplete: false,
      emailOrigin: "",
      loadingAutoComplete: false,
      getCollaboratorFilter: [],
      getCollaboratorLoading: false,
      token: "",
      url: "",
      firmante: false,
      userInformationFirstName: "",
      userInformationFirstLastName: "",
      userInformationSecondLastName: "",
      userInformationEmail: "",
      userInformationId: "",
      processTypes: [],
      processTypesInputValue: [],
      errorProcessTypeId: false,
      processTypeId: "",
      userType: "",
      services: [],
      showErrorDomain: false,
      showErrorDomainInvited: false,
      restOfTheMessage: "",
      emailDomains: "",
      messageSecond: "",
      requireSignSupport: false,
      collaboratorListAllow: [],
      inviteListAllow: [],
      timezone: null
    };
    DragCell.reorder = this.reorder.bind(this);
    DragCell.dragStart = this.dragStart.bind(this);
    this.toggleDialog = this.toggleDialog.bind(this);
    this.onDeleteData = this.onCancelData.bind(this);
  }

  notification = {
    type: {
      style: "error",
      icon: true,
    },
    style: {
      bottom: 85,
      right: 30,
      position: "fixed",
    },
  };

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  signatureRequestService = new SignatureRequestService(this.url);
  signerTypeService = new SignerTypeService(this.url);
  signatureTypesService = new SignatureTypesService(this.url);
  serviceService = new ServiceService(this.url);
  domainService = new DomainService(this.url);

  UserService = new UserService(this.url);
  contractService = new ContractService(this.url);
  processTypeService = new ProcessTypeService(this.url);
  localStorageService = new LocalStorageService();
  validator = SignatureRequestValidator(this.props.t);

  async componentDidMount() {
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    let userInformation = this.user.userMetaData.userA3Cloud;
    let userInformationMiFirma = this.user.userMetaData.userMifirma;
    let domains = await this.domainService.getDomains(this.token);

    let usersCollabotartorInvites = await this.UserService.getUsersCollaboratorInvite(this.token)
    if (!usersCollabotartorInvites) {
      usersCollabotartorInvites.usersCollaborator = []
      usersCollabotartorInvites.usersInvite = []
    }

    this.setState({
      emailDomains: domains
    })
    try {
      this.setState({
        userInformationId: userInformation.id,
        userInformationFirstName: userInformation.firstName,
        userInformationFirstLastName: userInformation.firstLastName,
        userInformationSecondLastName: userInformation.secondLastName,
        userInformationEmail: userInformation.email,
        userType: userInformationMiFirma.userType.id,
        collaboratorListAllow: usersCollabotartorInvites.usersCollaborator,
        inviteListAllow: usersCollabotartorInvites.usersInvite
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
    let signerTypes = initialState["signerTypeService.getSignerTypes"];
    if (!signerTypes) {
      signerTypes = await this.signerTypeService.getSignerTypes(this.token);
      initialState["signerTypeService.getSignerTypes"] = signerTypes;
    }
    let processTypes = initialState["processTypeService.getProcessTypes"];
    if (!processTypes) {
      processTypes = await this.processTypeService.getProcessTypes(this.token);
      initialState["processTypeService.getProcessTypes"] = processTypes;
    }

    let signatureTypes =
      initialState["signatureTypesService.getSignatureTypes"];
    if (!signatureTypes) {
      signatureTypes = await this.signatureTypesService.getSignatureTypes(
        this.token
      );
      initialState["signatureTypesService.getSignatureTypes"] = signatureTypes;
    }
    // let requests = await this.signatureRequestService.getSignatureRequests(
    //   0,
    //   1000,
    //   this.token
    // ); // Obtener todas las solicitudes enviadas para no repetir nombres

    // Obteniendo la zona horaria del navegador
    let navegatorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    let timezone = `${navegatorTimezone}`

    try {
      this.setState({
        signerTypes,
        processTypes,
        signatureTypes,
        timezone,
        // signatureRequests: requests.data,
        loadingContractsSignatures: true,
        token: this.token,
        url: this.url,
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
    this.email = this.localStorageService.getLocalStorageItem(
      "user"
    ).userMetaData.userMifirma.email;
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let contractValidation = await this.contractService.getContractsSignatures(
      this.email,
      this.token
    );
    try {
      this.setState({
        loadingContractsSignatures: false,
        contractsSignatures: contractValidation,
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
    let services = initialState["servicesService.getSignatureTypes"];
    if (!services) {
      services = await this.serviceService.getServices(this.token);

      // Delete the service ID 3 to the list of services (BORRAR DESPUES)
      for (let i = 0; i < services.length; i++) { if (services[i].id === 3) services.splice(i, 1) }

      initialState["servicesService.getSignatureTypes"] = services;
    }
    try {
      this.setState({
        services: services.map((i) => ({ ...i, isActive: false })),
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
  }

  reorder(dataItem) {
    const { key } = dataItem;
    if (
      this.state[key === "signers" ? "activeItem" : "activeItemValidator"]
        .email === dataItem.email
    ) {
      return;
    }
    let reorderedData = this.state[key].slice();
    let prevIndex = reorderedData.findIndex(
      (p) =>
        p.email ===
        this.state[key === "signers" ? "activeItem" : "activeItemValidator"]
          .email
    );
    let nextIndex = reorderedData.findIndex((p) => p.email === dataItem.email);
    reorderedData.splice(prevIndex, 1);
    reorderedData.splice(
      nextIndex,
      0,
      this.state[key === "signers" ? "activeItem" : "activeItemValidator"]
    );
    let params = {};
    params[key] = reorderedData;
    if (key === "signers") params.activeItem = this.state.activeItem;
    else params.activeItemValidator = this.state.activeItemValidator;
    this.setState(params);
  }

  dragStart(dataItem) {
    const { key } = dataItem;
    let params = {};
    params[key] = this.state[key];
    if (key === "signers") params.activeItem = dataItem;
    else params.activeItemValidator = dataItem;
    this.setState(params);
  }
  insertInToArray = (arr, index, newItem) => {
    return [...arr.slice(0, index), newItem, ...arr.slice(index)];
  };
  changeRows = (dataItem, sum, key) => {
    let currentSigner = {};
    let saveIndex = 0;

    if (dataItem.id_order === 1 && sum == -1) {
      let sendToLast = this.state[key].filter((item, index) => index !== 0);
      sendToLast.push(this.state[key][0]);
      this.setState({
        [key]: sendToLast,
      });

      return;
    }

    if (dataItem.isLastItem && sum == 1) {
      let sendToFirst = this.state[key].filter(
        (item, index, arr) => arr.length - 1 !== index
      );
      sendToFirst = [this.state[key][this.state[key].length - 1]].concat(
        sendToFirst
      );
      this.setState({
        [key]: sendToFirst,
      });

      return;
    }

    let tempSigners = this.state[key].filter((item, index) => {
      if (dataItem.email === item.email) {
        currentSigner = item;
        saveIndex = index;
      }
      return dataItem.email !== item.email;
    });
    tempSigners = this.insertInToArray(
      tempSigners,
      saveIndex + sum,
      currentSigner
    );

    this.setState({
      [key]: tempSigners,
    });
  };

  setSignatureTypes = (val) =>
    this.setState({
      signatureTypesInputValue: val,
      errorSignatureTypeId: false,
    });
  setProcessTypes = (val) =>
    this.setState({ processTypesInputValue: val, errorProcessTypeId: false });
  setServices = (services) => this.setState({ services });

  /**
   * @author Alan Aguilar
   * @description Method to close the alert of the form
   * @memberof SignatureRequestAction
   */
  onCloseOpenModal = () => {
    this.setState({ showNotification: false });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the notification and then close
   * @memberof SignatureRequestAction
   */
  handleMessage = (message) => {
    this.setState(
      {
        showNotification: true,
        message,
      },
      () => {
        setTimeout(() => {
          this.onCloseOpenModal();
        }, 8000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the delete signer dialog modal
   * @memberof SignatureRequestAction
   */
  toggleDialogDeleteSigner = (dataItem) => {
    this.setState({
      visibleDialogDeleteSigner: !this.state.visibleDialogDeleteSigner,
    });
    if (this.state.visibleDialogDeleteSigner === false) {
      this.setState({ signerToDelete: dataItem });
    } else {
      this.setState({ signerToDelete: "" });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @memberof SignatureRequestAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the confirmed sign dialog modal and redirecto to home
   * @memberof SignatureRequestAction
   */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
          let myStorage = window.localStorage;
          const tabSelected = {
            buttonFilterSelectedBlue: "table-button-blue-active",
            buttonFilterSelectedGreen: "",
            buttonFilterSelectedRed: "",
            buttonFilterSelectedOrange: "",
            buttonFilterSelectedGray: "",
          };
          myStorage.setItem("tabSelected", JSON.stringify(tabSelected));
          this.props.history.push("/");
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @memberof SignatureRequestAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show the error domain dialog modal
   * @memberof SignatureRequestAction
   */
  toggleErrorDomain = (value) => {
    this.setState(
      {
        showErrorDomain: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorDomain: false });
        }, 7000);
      }
    )
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show the invited domain error in dialog modal
   * @memberof SignatureRequestAction
   */
  toggleErrorDomainInvited = (value) => {
    this.setState(
      {
        showErrorDomainInvited: value,
      },
    )
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show or hide dialog
   * @memberof SignatureRequestAction
   */
  toggleDialog() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  /**
   * @author Lucia Alvarado
   * @description Method to hide the dialog
   * @memberof SignatureRequestAction
   */
  onCancelData() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  /**
   * @author Lucia Alvarado
   * @description Insert new signer in the grid
   * @memberof SignatureRequestAction
   */
  insert = () => {
    this.setState({
      signerInEdit: {},
      buttonType: 0,
    });
  };

  insertCollaborator = () => {
    this.setState({
      signerInEdit: {},
      buttonType: 2,
    });
  };

  insertValidator = () => {
    this.setState({
      signerInEdit: {},
      buttonType: 4,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Add a signer
   * @param {Object} dataItem
   * @memberof SignatureRequestAction
   */
  newSigner(dataItem) {
    const id = ++this.idCounter;
    const newSigner = {
      id: id,
      email: "",
      signerType: "",
    };
    return Object.assign(newSigner, dataItem);
  }

  selectSigner = (params) => this.setState({ signerInEdit: params }, () => this.save());

  /**
   * @author Lucia Alvarado
   * @description Save data of dialog
   * @memberof SignatureRequestAction
   */
  save = async () => {
    let signerExist = false;
    let { nameSigner, lastNameSigner, email } = this.state.signerInEdit;

    let nameValid = this.validator.nameValidator(nameSigner);
    if (nameSigner === undefined || nameSigner === "" || nameValid !== "") {
      this.setState({
        errorCurrentName: true,
      });
      return false;
    }

    let lastNameValid = this.validator.nameValidator(lastNameSigner);
    if (
      lastNameSigner === undefined ||
      lastNameSigner === "" ||
      lastNameValid !== ""
    ) {
      this.setState({
        errorCurrentLastName: true,
      });
      return false;
    }

    let emailValid =
      email !== undefined &&
      email !== "" &&
      this.validator.emailValidator(email);
    if ((email === null && email === "") || emailValid !== "") {
      this.setState({
        errorCurrentEmail: true,
        errorCurrentEmailRegister: false,
      });
      return false;
    } else {
      this.setState({
        errorCurrentEmail: false,
      });
    }
    if (email === "") {
      this.setState({
        errorCurrentEmailRegister: false,
      });
    }
    if (this.state.buttonType !== 1) {//agregar
      if (this.state.userIsEditing === false) {
        const listToCheck = this.state.buttonType === 4 ? this.state.validators : this.state.signers;
        listToCheck.forEach((signer) => {
          if (signer.email === email) {
            signerExist = true;
          }
        })
        if (signerExist === true) {
          this.setState({
            errorCurrentEmailRegister: true,
            errorCurrentEmail: false,
          });
          return false;
        } else {
          this.setState({
            errorCurrentEmailRegister: false,
          });
          let dataItem = this.state.signerInEdit;
          dataItem.nameSigner = `${nameSigner} ${lastNameSigner}`

          const signers = this.state.signers.slice();
          const validators = this.state.validators.slice();
          const isNewSigner = dataItem.id === undefined;
          if (this.state.buttonType === 2 || this.state.buttonType === 4) {
            let userEmailByDomain = dataItem.email;
            let emailDomainSplit = userEmailByDomain.split("@")[1];
            let emailForbidden = true;

            for (var i = 0; i < this.state.emailDomains.length; i++) {
              if (emailDomainSplit === this.state.emailDomains[i].name) {
                emailForbidden = false;
                break;
              }
            }
            if (emailForbidden) {
              this.setState({ message: this.props.t('signatureRequest.pure.errorDomain'), messageSecond: this.props.t('signatureRequest.pure.errorDomainS'), restOfTheMessage: this.props.t('signatureRequest.pure.errorDomainAll') })
              this.toggleLoadingRequesting(false)
              this.toggleErrorDomain(true)
              return false;
            }
          }
          if (this.state.buttonType === 0) {
            let userEmailByDomain = dataItem.email;
            let emailDomainSplit = userEmailByDomain.split("@")[1];
            let emailForbidden = true;
            for (var i = 0; i < this.state.emailDomains.length; i++) {
              if (emailDomainSplit === this.state.emailDomains[i].name) {
                emailForbidden = false;
                break;
              }
            }
            if (!emailForbidden) {
              this.setState({ message: this.props.t('signatureRequest.pure.errorDomainInvited') })
              dataItem.type = Number(
                process.env.REACT_APP_SIGNERS_TYPE_COLABORADOR
              );
              dataItem.typeName = "Colaborador";
              this.toggleLoadingRequesting(false)
              this.toggleErrorDomainInvited(true)
              return false;
            }
          }

          if (this.state.buttonType === 2) {
            dataItem.type = Number(
              process.env.REACT_APP_SIGNERS_TYPE_COLABORADOR
            );
            dataItem.typeName = "Colaborador";
          }
          if (this.state.buttonType === 4) {
            dataItem.type = Number(
              process.env.REACT_APP_SIGNERS_TYPE_VALIDATOR
            );
            dataItem.typeName = "Autorizador";
          }
          if (isNewSigner) {
            if (this.state.buttonType === 4) {
              validators.unshift(this.newSigner(dataItem));
            } else {
              signers.unshift(this.newSigner(dataItem));
            }
          } else if (this.state.buttonType !== 4) {
            const index = signers.findIndex((p) => p.email === dataItem.email);
            signers.splice(index, 1, dataItem);
          } else {
            const index = validators.findIndex(
              (p) => p.email === dataItem.email
            );
            validators.splice(index, 1, dataItem);
          }
          this.setState({
            signers: signers,
            validators: validators,
            signerInEdit: undefined,
            userIsEditing: false,
            errorNotSigners: false,
            errorNotValidators: false,
            errorSignerType: false,
            errorCurrentName: false,
            errorCurrentLastName: false,
          });
        }
      }
    } else if (this.state.buttonType === 1) {// editar
      if (this.state.userIsEditing === false) {
        let currentSigners = this.state.signers;
        if (currentSigners.length > 0) {
          currentSigners.forEach((signer) => {
            if (signer.email === email) {
              signerExist = true;
            }
          });
          if (signerExist === true) {
            this.setState({
              errorCurrentEmailRegister: true,
              errorCurrentEmail: false,
            });
            return false;
          } else {
            this.setState({
              errorCurrentEmailRegister: false,
            });
            this.state.signers.forEach((signer) => {
              if (signer.email === this.state.emailOrigin) {
                signer.email = email;
              }
            });
            this.setState({
              signerInEdit: undefined,
            });
          }
        }
      }
    }
  };

  /**
   * @author Adrian Montemayor
   * @description Confirm data of domain
   * @memberof SignatureRequestAction
   */
  confirm = async () => {
    let dataItem = this.state.signerInEdit;

    const signers = this.state.signers.slice();
    const validators = this.state.validators.slice();
    const isNewSigner = dataItem.id === undefined;
    if (isNewSigner) {
      if (this.state.buttonType === 4) {
        validators.unshift(this.newSigner(dataItem));
      } else {
        signers.unshift(this.newSigner(dataItem));
      }
    } else if (this.state.buttonType !== 4) {
      const index = signers.findIndex((p) => p.email === dataItem.email);
      signers.splice(index, 1, dataItem);
    } else {
      const index = validators.findIndex(
        (p) => p.email === dataItem.email
      );
      validators.splice(index, 1, dataItem);
    }
    this.setState({
      signers: signers,
      validators: validators,
      signerInEdit: undefined,
      userIsEditing: false,
      errorNotSigners: false,
      errorNotValidators: false,
      errorSignerType: false,
      errorCurrentName: false,
      errorCurrentLastName: false,
      showErrorDomainInvited: false,
    });
  }

  /**
   * @author Lucia Alvarado
   * @description Edit a signer
   * @param {Object} dataItem
   * @memberof SignatureRequestAction
   */
  edit = (dataItem) => {
    this.setState({
      emailOrigin: dataItem.email,
      signerInEdit: this.cloneSigner(dataItem),
      // userIsEditing: true,
      buttonType: 1,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Duplicate data signer for the grid
   * @param {Object} signer
   * @memberof SignatureRequestAction
   */
  cloneSigner(signer) {
    return Object.assign({}, signer);
  }

  /**
   * @author Lucia Alvarado
   * @description Remove a signer of grid
   * @memberof SignatureRequestAction
   */

  remove = () => {
    let params = {
      visibleDialogDeleteSigner: false,
      signerToDelete: "",
    };
    if (this.state.signerToDelete.is === "signer")
      params.signers = this.state.signers.filter(
        (p) => p.email !== this.state.signerToDelete.email
      );
    if (this.state.signerToDelete.is === "validator")
      params.validators = this.state.validators.filter(
        (p) => p.email !== this.state.signerToDelete.email
      );
    this.setState(params);
  };

  /**
   * @author Lucia Alvarado
   * @description Method to clear and hide dialog
   * @memberof SignatureRequestAction
   */
  cancel = () => {
    this.setState({
      signerInEdit: undefined,
      disableSignerButton: true,
      errorCurrentEmail: false,
      errorCurrentEmailRegister: false,
      errorSignerType: false,
      errorCurrentName: false,
      errorCurrentLastName: false,
      showErrorDomainInvited: false
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to change the signerTypeSelected in combobox
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  onChangeCombobox = (event) => {
    this.setState({
      signerTypesSelected: event.target.value,
    });
  };

  /**
   * @author Leonel Contreras
   * @description Add eventId generation
   * @param {*} event
   */
  handleChangeCheckbox = (event) => {
    let eventId = hash({ hash: Math.random().toString(36).substring(7) });

    this.setState({
      documentAccept: event.value,
      eventId,
    });
  };

  handleChangeCheckboxTF = (event) => {
    this.setState({
      firmante: event.value,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Change the title dialog
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  dialogTitle() {
    return `${this.state.signerInEdit.id === undefined ? "Agregar firmante" : "Edit"
      } product`;
  }

  /**
   * @author Lucia Alvarado
   * @description Method to save form of the dialog
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  handleSubmit = (event) => {
    event.preventDefault();
    this.save();
    this.setState({ disableSignerButton: true });
  };

  handleSubmitConfirm = (event) => {
    event.preventDefault();
    this.confirm();
    this.setState({ disableSignerButton: true });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to change the data of form dialog
   * @param {Event} event
   * @memberof SignatureRequestAction
   */

  onDialogInputChange = async (event) => {
    this.setState({
      autocomplete: false,
      firstLastName: "",
      firstName: "",
      getUserNameFilter: {},
    });
    let target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.props ? target.props.name : target.name;

    const edited = this.state.signerInEdit;
    edited[name] = value;
    if (name === 'numSign') {
      edited[name] = value > 99 ? 99 : value;
    }
    // if (edited.email === "") {
    //   edited.nameSigner = "";
    //   edited.lastNameSigner = "";
    // }
    this.setState({
      signerInEdit: edited,
    });

    let nameValid = "";
    if (name === "nameSigner") nameValid = this.validator.nameValidator(value);

    if (this.state.signerInEdit.nameSigner !== null && nameValid === "") {
      this.setState({
        errorCurrentName: false,
        disableSignerButton: false,
        autocomplete: true,
      });
    } else {
      this.setState({
        errorCurrentName: true,
        disableSignerButton: true,
      });
    }

    let lastNameValid = "";
    if (name === "lastNameSigner")
      lastNameValid = this.validator.nameValidator(value);

    if (
      this.state.signerInEdit.lastNameSigner !== null &&
      lastNameValid === ""
    ) {
      this.setState({
        errorCurrentLastName: false,
        disableSignerButton: false,
        autocomplete: false,
      });
    } else {
      this.setState({
        errorCurrentLastName: true,
        disableSignerButton: true,
      });
    }
    try {
      if (name === "email")
        if (
          this.state.signerInEdit.email !== null &&
          this.validator.emailValidator(this.state.signerInEdit.email) === ""
        ) {
          this.setState({
            errorCurrentEmail: false,
            disableSignerButton: false,
            autocomplete: true,
          });
          if (!this.state.getUserEmailFilterLoading) {
            this.state.getUserEmailFilter.forEach((item) => {
              if (item === value) {
                this.getUserName(item);
                //if(!this.state.getUserNameFilterLoading){
                edited.nameSigner = this.state.getUserNameFilter.firstName;
                edited.lastNameSigner = this.state.getUserNameFilter.firstLastName;
                this.setState({
                  firstLastName: this.state.getUserNameFilter.firstLastName,
                  firstName: this.state.getUserNameFilter.firstName,
                  getEmail: this.state.getUserNameFilter.email,
                });
                //}
              }
            });
          }
        } else {
          this.setState({
            errorCurrentEmail: true,
            disableSignerButton: true,
            autocomplete: false,
          });
        }
    } catch (error) { }

    // if(this.state.signerInEdit.signerTypeSelected !== null){
    //   this.setState({
    //     errorSignerType: false,
    //     disableSignerButton: false
    //   })
    // } else {
    //   this.setState({
    //     errorSignerType: true,
    //     disableSignerButton: true
    //   })
    // }
  };

  getUserEmail = async (value) => {
    this.setState({
      loadingAutoComplete: true,
      getUserEmailFilterLoading: true,
    });
    //let getUserEmailFilter = await this.UserService.getUserEmail(value, this.token)
    let getUserEmailFilter = await this.UserService.getInvitados(
      value,
      this.token
    );
    this.setState({
      getUserEmailFilterLoading: false,
      getUserEmailFilter,
      loadingAutoComplete: false,
    });
  };

  getUserName = async (value) => {
    const edited = this.state.signerInEdit;
    //this.setState({ getUserNameFilterLoading: true })
    const arrayNames = [];
    let getUserNameFilter = await this.UserService.getUserName(
      value,
      this.token
    );
    this.setState({ getUserNameFilterLoading: false, getUserNameFilter });
    let id = 0;
    if (this.state.signers.length > 0) {
      const element = this.state.signers[0].id_order;

      id = element + 1;
    }
    edited.nameSigner = getUserNameFilter ? getUserNameFilter.firstName : "";
    edited.lastNameSigner = getUserNameFilter
      ? getUserNameFilter.firstLastName
      : "";
    edited.type = 3;
    edited.typeName = "Invitado";
    edited.id_order = id;
    this.setState({
      signerInEdit: edited,
    });
    arrayNames.push(getUserNameFilter);
  };

  getCollaborator = async (value) => {
    this.setState({ getCollaboratorLoading: true });
    let getUserNameFilter = await this.UserService.getCollaborator(
      value,
      this.token
    );
    this.setState({
      getCollaboratorLoading: false,
      getCollaboratorFilter: getUserNameFilter,
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.processTypesInputValue !== prevState.processTypesInputValue
    ) {
      let processType =
        this.state.processTypesInputValue.find((item) => item.isActive) ?? {};
      let processTypeId = processType?.id;
      this.setState({ processTypeId: processTypeId });
    }
    if (this.state.getUserNameFilter !== prevState.getUserNameFilter) {
      if (!this.state.getUserNameFilterLoading) {
      }
    }
    if (this.state.firmante !== prevState.firmante) {
      if (!this.state.firmante) {
        for (var i = 0; i < this.state.signers.length; i++) {
          if (this.state.signers[i].email === this.state.userInformationEmail) {
            this.state.signers.splice(i, 1);
            this.setState({ signers: this.state.signers });
            break;
          }
        }
      }
    }
  }
  /* ====== START - HANDLER METHODS FOR DISPLAY PDF ====== */

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  /**
   * @author Alan Aguilar
   * @description Method to get the file
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  handleFile = async (e) => {
    let result = e.target.files[0].name.slice(-4);
    if (result === ".pdf" || result === ".PDF") {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        errorFile: false,
        colorBorderContainer: "green",
      });

      // Upload the base64 in the state
      let fileBase64 = await this.pdfToBase64(e.target.files[0]);
      let pdfBase64 = fileBase64.split(",")[1];
      this.setState({ selectedFileBase64: pdfBase64 });
    } else {
      this.setState({
        selectedFile: null,
        errorFile: true,
        selectedFileBase64: "",
        colorBorderContainer: "gray",
      });
      return false;
    }
  };

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      deletePfd: true,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
    });
    return true;
  };

  /**
   * @author Alan Aguilar
   * @description Method to show file
   * @memberof SignatureRequestAction
   */
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
    this.setState({ pageNumber: 1 });
    this.setState({ errorFile: false });
    this.fillPagesArray(numPages);
  };

  /**
   * @author Alan Aguilar
   * @description Method to add page of the file
   * @memberof SignatureRequestAction
   */
  fillPagesArray = (numPages) => {
    let pages = [];
    for (let i = 1; i <= numPages; i++) {
      pages.push(i);
    }
    // this.setState({ pagesArray: pages })

    let optionsRendered = pages.map((item, index) => {
      return (
        <option key={index} value={item}>
          {item}
        </option>
      );
    });
    this.setState({ pagesArray: optionsRendered });
  };

  /**
   * @author Alan Aguilar
   * @description Method to go to the page selected
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  goToSelectPage = (event) => {
    let pageSelected = event.target.value;
    this.setState({ pageNumber: Number(pageSelected) });
  };
  /**
   * @author Alan Aguilar
   * @description Method to go to the page before
   * @memberof SignatureRequestAction
   */
  goToPrevPage = () => {
    if (this.state.numPages === null || this.state.pageNumber === 1) return;
    let prevPage = this.state.pageNumber - 1;
    this.setState({ pageNumber: prevPage });
  };

  /**
   * @author Alan Aguilar
   * @description Method to go to the next page
   * @memberof SignatureRequestAction
   */
  goToNextPage = () => {
    if (
      this.state.numPages === null ||
      this.state.pageNumber >= this.state.numPages
    )
      return;
    let nextPage = this.state.pageNumber + 1;
    this.setState({ pageNumber: nextPage });
  };

  /**
   * @author Alan Aguilar
   * @description Method to zoom page selected
   * @memberof SignatureRequestAction
   */
  onZoomIn = () => {
    if (this.state.numPages === null) return;
    let addZoom = this.state.zoom + 0.5;
    this.setState({ zoom: addZoom });
  };

  /**
   * @author  Alan Aguilar
   * @description Method to zoom out page selected
   * @memberof SignatureRequestAction
   */
  onZoomOut = () => {
    if (this.state.numPages === null) return;
    let removeZoom = this.state.zoom - 0.5;
    this.setState({ zoom: removeZoom });
  };

  /* ====== END - HANDLER METHODS FOR DISPLAY PDF ====== */

  /**
  * @author Alan Aguilar
  * @description Method to save the comments in the state from textarea
  * @updatedDate 30-07-2021
  * @memberof SignatureRequestAction
  */
  onChangeComments = (e) => {
    this.setState({ comments: e.target.value }, () => {
      let commentsValid = this.validator.commentsValidator(this.state.comments)
      if (commentsValid && commentsValid !== "") {
        this.setState({ errorCurrentComments: true })
      } else {
        this.setState({ errorCurrentComments: false })
      }
    })
  }

  /**
* @author Alan Aguilar
* @description Method to save the summary of the document to be signed
* @updatedDate 26-10-2021
* @memberof SignatureRequestAction
*/
  onChangeSummaryDescription = (e) => {
    this.setState({ description: e.target.value }, () => {
      let descriptionValid = this.validator.descriptionValidator(this.state.description)
      if (descriptionValid && descriptionValid !== "") {
        this.setState({ errorCurrentDescription: true })
      } else {
        this.setState({ errorCurrentDescription: false })
      }
    })
  }

  /**
   * @author  Lucia Alvarado
   * @description Method to move scroll
   * @memberof SignatureRequestAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  /**
   * @author Lucia Alvarado
   * @description Handle the submit event
   * @param {Event} event
   * @memberof SignatureRequestAction
   */
  onSubmit = async (dataItem) => {
    this.setState({ message: null })

    if (this.state.errorCurrentDescription === true) {
      return false
    }
    if (this.state.errorCurrentComments === true) {
      return false
    }

    if (this.state.selectedFile === null) {
      this.setState({ errorFile: true })
      return false
    } else {
      this.setState({ errorFile: false })
    }

    let result = this.state.selectedFile.name.slice(-4);
    if (result.toLowerCase() !== ".pdf") {
      this.setState({ errorFile: true })
      return false
    } else {
      this.setState({ errorFile: false })
    }

    let signatureType = this.state.signatureTypesInputValue.find((item) => item.isActive) ?? {};
    let signatureTypeId = signatureType?.id
    if (!signatureTypeId) {
      this.setState({ errorSignatureTypeId: true })
      return false
    }

    let processType = this.state.processTypesInputValue.find((item) => item.isActive) ?? {};
    let processTypeId = processType?.id
    if (!processTypeId) {
      this.setState({ errorProcessTypeId: true })
      return false
    }

    if (this.state.documentAccept === false) {
      this.setState({ errorAcceptDocument: true })
      return false
    } else {
      this.setState({ errorAcceptDocument: false })
    }

    if (this.state.signers.length <= 0) {
      this.setState({ errorNotSigners: true })
      return false
    } else {
      this.setState({
        errorNotSigners: false,
      })
    }

    if (
      this.state.validators.length <= 0 &&
      (this.state.processTypeId ===
        Number(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL) ||
        this.state.processTypeId ===
        Number(
          process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL
        ))
    ) {
      this.setState({ errorNotValidators: true })
      return false
    } else {
      this.setState({ errorNotValidators: false })
    }
    if (this.state.notification === true) this.onCloseOpenModal()

    try {
      await this.toggleLoadingRequesting(true)

      // Eliminar el nombre y apellido completo del valor nameSigner
      this.state.signers.map(signer => {
        let fullName = signer.nameSigner
        let onlyLastName = signer.lastNameSigner
        let onlyFirstName = fullName.split(onlyLastName)[0].trim()
        signer.nameSigner = onlyFirstName
      })

      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_RANDOM)
      ) {
        dataItem.signers = this.state.signers.map((signer) => ({
          // ...signer,
          email: signer.email,
          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId:
            signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
        }))
      }

      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL)
      ) {
        dataItem.signers = this.state.signers.map((signer, index) => ({
          // ...signer,
          email: signer.email,
          numSign: signer.numSign,

          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId:
            signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
          order: index + 1,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
        }))
      }

      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL)
      ) {
        let tempSigners = this.state.signers.map((signer) => ({
          // ...signer,
          email: signer.email,
          numSign: signer.numSign,
          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId:
            signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
        }))

        let tempValidators = this.state.validators.map((signer) => ({
          // ...signer,
          email: signer.email,
          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId: signer.type,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
        }));
        dataItem.signers = tempSigners.concat(tempValidators)
      }

      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL)
      ) {
        let tempSigners = this.state.signers.map((signer, index) => ({
          // ...signer,
          email: signer.email,
          numSign: signer.numSign,
          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId:
            signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
          order: index + 1,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
        }))

        let tempValidators = this.state.validators.map((signer, index) => ({
          // ...signer,
          email: signer.email,
          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId: signer.type,
          order: index + 1,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
        }));
        dataItem.signers = tempSigners.concat(tempValidators)
      }

      let { signers, name, limitDate } = dataItem
      signers = signers.map((item) => {
        let current = this.state.signers.find(i => i.email === item.email)
        if (current) {
          return {
            ...item,
            numSign: current.numSign
          }
        }
        return item
      })
      let { description, comments, eventId, services, documentAccept, requireSignSupport, selectedFile, timezone } = this.state
      // Generate Array servicesId
      let servicesId = services
        .filter((i) => i.isActive)
        .map((i) => i.id)

      let signRequestBody = new FormData()
      signRequestBody.append("name", name)
      signRequestBody.append("description", description)
      signRequestBody.append("comments", comments)
      signRequestBody.append("eventId", eventId)
      signRequestBody.append("signers", JSON.stringify(signers))
      signRequestBody.append("limitDate", limitDate)
      signRequestBody.append("documentAccept", documentAccept)
      signRequestBody.append("signatureTypeId", signatureTypeId)
      signRequestBody.append("servicesId", JSON.stringify(servicesId))
      signRequestBody.append("processTypeId", processTypeId)
      signRequestBody.append("requireSignSupport", requireSignSupport)
      signRequestBody.append("file", selectedFile)
      signRequestBody.append("timezone", timezone)
      signRequestBody.append("lastInteraction", new Date())

      const signRequest = await this.signatureRequestService.createSignatureRequest(signRequestBody, this.token)
      if (signRequest && signRequest.statusCode === 200) {
        await this.toggleLoadingRequesting(false)
        await this.toggleCompletedRequesting(true)
        return true
      } else {
        switch (signRequest.statusCode) {
          case -1:
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -2:
            this.setState({
              message: this.props.t("signatureRequestAction2.dateError"),
            });
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -3:
            this.setState({
              message: this.props.t("signatureRequestAction2.termsConditionsError"),
            });
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -5:
            this.setState({
              message: this.props.t("signatureRequestAction2.signatureError"),
            });
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -6:
            this.setState({
              message: this.props.t("signatureRequestAction2.flowError"),
            });
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -7:
            this.setState({
              message: this.props.t("signatureRequest.pure.errorDomain"),
              messageSecond: this.props.t('signatureRequest.pure.errorDomainS'),
              restOfTheMessage: this.props.t("signatureRequest.pure.errorDomainAll"),
            });
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorDomain(true)
            return false
          case 403:
            this.setState({
              message: this.props.t("signatureRequestAction2.adminMessageError"),
            });
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case 420:
            this.setState({
              message: this.props.t("signatureRequestAction2.dataMessageError"),
            });
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          default:
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
        }
      }
    } catch (error) {
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  setSigners = (valSigners) => this.setState({ signers: valSigners })

  setValidators = (valValidators) => this.setState({ validators: valValidators })

  changeSignerInEdit = (nameSigner, lastNameSigner) => {
    let signerInEdit = { ...this.state.signerInEdit }
    signerInEdit.nameSigner = nameSigner
    signerInEdit.lastNameSigner = lastNameSigner
    this.setState({ signerInEdit })
  }

  changeSignerEmailInEdit = (email) => {
    let signerInEdit = { ...this.state.signerInEdit }
    signerInEdit.email = email
    this.setState({ signerInEdit })
  }

  render() {
    if (this.state.loadingContractsSignatures) {
      return (
        <div className="loading-signature-request">
          <SimpleLoading />
        </div>
      );
    }
    if (
      this.state.contractsSignatures &&
      this.state.contractsSignatures.data === true
    ) {
      return (
        <SignatureRequestView
          {...this.state}
          history={this.props.history}
          changeSignerInEdit={this.changeSignerInEdit}
          changeSignerEmailInEdit={this.changeSignerEmailInEdit}
          signers={this.state.signers.map((item, index, arr) => ({
            ...item,
            numSign: item.numSign,
            is: "signer",
            type:
              item.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            typeName: item.typeName ?? "Invitado",
            id_order: index + 1,
            isLastItem: arr.length - 1 === index,
          }))}
          validators={this.state.validators.map((item, index, arr) => ({
            ...item,
            is: "validator",
            id_order: index + 1,
            isLastItem: arr.length - 1 === index,
          }))}
          DragCell={DragCell}
          changeRows={this.changeRows}
          setSigners={this.setSigners}
          setValidators={this.setValidators}
          validator={this.validator}
          regex={this.regex}
          validateInput={ValidateInputPure}
          onSubmit={this.onSubmit}
          handleChangeEventSignature={this.handleChangeEventSignature}
          toggleDialog={this.toggleDialog}
          onCancelData={this.onCancelData}
          handleChangeCheckbox={this.handleChangeCheckbox}
          handleChangeCheckboxTF={this.handleChangeCheckboxTF}
          saveDialog={this.saveDialog}
          save={this.save}
          edit={this.edit}
          remove={this.remove}
          cancel={this.cancel}
          insert={this.insert}
          insertCollaborator={this.insertCollaborator}
          insertValidator={this.insertValidator}
          dialogTitle={this.dialogTitle}
          cloneProduct={this.cloneProduct}
          newProduct={this.newProduct}
          handleName={this.handleName}
          handleDescription={this.handleDescription}
          handleSubmit={this.handleSubmit}
          handleSubmitConfirm={this.handleSubmitConfirm}
          selectSigner={this.selectSigner}
          onDialogInputChange={this.onDialogInputChange}
          handleFile={this.handleFile}
          handleDeleteFile={this.handleDeleteFile}
          onDocumentLoadSuccess={this.onDocumentLoadSuccess}
          goToPrevPage={this.goToPrevPage}
          goToNextPage={this.goToNextPage}
          onZoomIn={this.onZoomIn}
          onZoomOut={this.onZoomOut}
          goToSelectPage={this.goToSelectPage}
          notification={this.notification}
          onCloseOpenModal={this.onCloseOpenModal}
          toggleLoadingRequesting={this.toggleLoadingRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          toggleErrorRequesting={this.toggleErrorRequesting}
          toggleDialogDeleteSigner={this.toggleDialogDeleteSigner}
          token={this.token}
          getCollaborator={this.getCollaborator}
          UserService={this.UserService}
          onChangeComments={this.onChangeComments}
          onChangeSummaryDescription={this.onChangeSummaryDescription}
          setSignatureTypes={this.setSignatureTypes}
          setProcessTypes={this.setProcessTypes}
          setServices={this.setServices}
          resetNotErrors={() =>
            this.setState({ errorNotValidators: false, errorNotSigners: false })
          }
          scrollWindow={this.scrollWindow}
          toggleErrorDomain={this.toggleErrorDomain}
          toggleErrorDomainInvited={this.toggleErrorDomainInvited}
          setRequireSignSupport={() => this.setState({ requireSignSupport: !this.state.requireSignSupport })}
        />
      );
    } else {
      return (
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          style={globalContainerStyles}
        >
          <VerifyContract />
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            style={containerInformationContactPlanStyles}
          >
            <Grid
              container
              spacing={2}
              style={gridInformationContactPlanStyles}
            >
              <PromotionalFooterPure />
            </Grid>
          </Container>
        </Container>
      );
    }
  }
}

function SignatureRequestActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <SignatureRequestAction {...props} t={t} setShowError={setShowError} />
  );
}

export { SignatureRequestActionContainer as default };